<script setup lang="ts">
import BaseButton from './BaseButton.vue';

interface Props {
  size?: 'small' | 'large';
  htmlType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  htmlType: 'button',
  loading: false,
  disabled: false,
  block: false,
});
</script>

<template>
  <BaseButton v-bind="props" type="default" class="button-secondary">
    <slot></slot>
    <template v-for="slotName in Object.keys($slots)" #[slotName]>
      <slot :name="slotName"></slot>
    </template>
  </BaseButton>
</template>

<style lang="less" scoped>
.ant-btn.button-secondary {
  background-color: @color-mid-tone;
  border-color: @color-mid-tone;
  color: @color-primary;

  &:hover {
    background-color: @color-background-dark;
    border-color: @color-background-dark;
  }

  &:active {
    color: fade(@color-primary, 70%);
  }

  &:focus {
    background-color: @color-mid-tone;
    border-width: 2px;
    border-color: @color-primary;
  }
}

.ant-btn.button-secondary[disabled],
.ant-btn.button-secondary[disabled]:hover,
.ant-btn.button-secondary[disabled]:focus,
.ant-btn.button-secondary[disabled]:active {
  background-color: fade(@color-mid-tone, 60%);
  border-color: fade(@color-mid-tone, 60%);
  color: fade(@color-primary, 50%);
  cursor: not-allowed;
}
</style>
